import React from 'react';
import ListResultsBar from '@/components/shared/ListResultsBar';
import type { FilterType } from './FamilyMembersFilterBar';

interface MembersResultsBarProps {
  totalResults: number;
  filter: FilterType;
  searchQuery: string;
}

const MembersResultsBar: React.FC<MembersResultsBarProps> = ({ totalResults, filter, searchQuery }) => {
  const trimmedQuery = searchQuery.trim();
  let countLabel: string;

  if (trimmedQuery) {
    countLabel = `${totalResults} ${totalResults === 1 ? 'match' : 'matches'} for "${trimmedQuery}"`;
  } else if (filter === 'pets') {
    countLabel = `${totalResults} ${totalResults === 1 ? 'pet' : 'pets'}`;
  } else {
    countLabel = `${totalResults} ${totalResults === 1 ? 'member' : 'members'}`;
  }

  return <ListResultsBar countLabel={countLabel} />;
};

export default MembersResultsBar;
